import React from 'react';
import { MATERIALS } from '../../game/constants';
import type { ParticleType } from '../../game/constants';
import { useIsMobile } from '../../hooks/useIsMobile';
import type { Locale } from '../../i18n';
import { getToolLabel } from '../../i18n';

interface MaterialPanelProps {
    isOpen: boolean;
    selectedParticle: ParticleType;
    onSelect: (type: ParticleType) => void;
    panelRef: React.RefObject<HTMLDivElement | null>;
    locale: Locale;
}

export const MaterialPanel: React.FC<MaterialPanelProps> = ({
    isOpen,
    selectedParticle,
    onSelect,
    panelRef,
    locale
}) => {
    const isMobile = useIsMobile();

    return (
        <div 
            ref={panelRef}
            className={`
            absolute bottom-full mb-4 left-1/2 -translate-x-1/2 z-20 
            bg-slate-900/95 backdrop-blur-xl border border-slate-700/50 p-4 rounded-2xl shadow-2xl 
            transition-all duration-300 origin-bottom
            grid grid-cols-5 sm:grid-cols-6 gap-2 w-max max-w-[90vw]
            ${isOpen ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-95 translate-y-4 pointer-events-none'}
        `}>
            {MATERIALS.map((tool) => {
                const toolLabel = getToolLabel(locale, tool.type, tool.label);
                return (
                  <button
                    key={tool.type}
                    onClick={() => onSelect(tool.type)}
                    className={`
                        relative px-3 py-2 rounded-xl text-sm font-medium transition-all duration-200 whitespace-nowrap
                        flex flex-col items-center gap-1 min-w-[4rem] group cursor-pointer
                        ${selectedParticle === tool.type 
                            ? 'bg-teal-500/15 text-teal-300 shadow-[0_0_15px_-3px_rgba(20,184,166,0.3)] ring-1 ring-teal-500/30' 
                            : 'text-slate-400 hover:text-slate-200 hover:bg-slate-800'}
                    `}
                    title={`${toolLabel} (${tool.shortcut.toUpperCase()})`}
                >
                    <span className="text-sm">{toolLabel}</span>
                    {!isMobile && (
                        <span className={`text-[10px] font-mono transition-colors ${
                            selectedParticle === tool.type ? 'text-teal-500/70' : 'text-slate-600 group-hover:text-slate-500'
                        }`}>
                            {tool.shortcut.toUpperCase()}
                        </span>
                    )}
                  </button>
                );
            })}
        </div>
    );
};
